import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { disableDarkModeIfNoLightsInScene } from 'rangeConfig/shared/utils/darkMode';

const removeInnerLightsFromProduct = ({
  coreApi,
  rootState: {
    layout: { darkScene }
  }
}: BehaviorParameters) => {
  const entity = coreApi.entities.findSelectedEntity();

  if (!entity) return;

  const lights = coreApi.entities.getChildrenWithProductType(
    entity,
    ProductType.PLATSA_INNER_LIGHT
  );

  if (lights.length > 0) {
    lights.forEach(light => coreApi.entities.delete(light));
    disableDarkModeIfNoLightsInScene(coreApi, darkScene);
  }
};

export default removeInnerLightsFromProduct;
